import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from './serviceWorker'; 

const rootNode = document.querySelector("#root");

ReactDOM.render(<App />, rootNode);
serviceWorker.unregister();